import React, { useEffect, useMemo } from "react";
import { ArrowLeftIcon } from "@phosphor-icons/react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useLocation, useNavigate } from "react-router-dom";

import { useCompaniesSlice } from "pages/Companies/slice/index";
import { selectCompanies, showMarketers } from "pages/Companies/slice/selector";

import { CompaniesWrapperStyles } from "pages/Companies/styled";
import marketerColumns from "pages/MarketerColumn/marketerColumns";

import Icon from "components/Icon/Icon";
import CommonTable from "components/Tables/CommonTable";

import { CompanyNameCell, renderValue } from "utils/renderCompanyCell";

import { CommonDashboardWrapper } from "styles/GlobalStyles";

const MarketersPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { actions } = useCompaniesSlice();

  const { companyId } = useParams();
  const location = useLocation();
  const passedCompany = location.state?.company;

  const { companies } = useSelector(selectCompanies);
  const { marketers, pagination, initialLoading, loading, total_marketers } =
    useSelector(showMarketers);

  const activeCompany =
    passedCompany || companies.find((c) => c.id.toString() === companyId);

  useEffect(() => {
    if (companyId) {
      dispatch(actions.fetchMarketers({ companyId }));
    }
  }, [companyId, dispatch]);

  const tableColumns = useMemo(() => marketerColumns(), []);

  const handleGoBack = () => {
    // Use the query from URL if state is empty
    const query = location.state?.prevSearch || window.location.search;
    navigate(`/companies${query}`);
  };

  return (
    <CommonDashboardWrapper>
      <CompaniesWrapperStyles>
        <div className="go-back-wrapper">
          <div className="go-back-icon" onClick={handleGoBack}>
            <Icon component={ArrowLeftIcon} format="outline" weight="regular" />
          </div>

          {activeCompany && (
            <div className="update-text-wrapper">
              <CompanyNameCell
                logo={activeCompany?.logo}
                name={renderValue(activeCompany?.company_name)}
                suffix="&lsquo;s" // optional
              />
              <h4>Users</h4>
            </div>
          )}
        </div>
      </CompaniesWrapperStyles>

      <CommonTable
        data={marketers}
        pagination={pagination}
        columns={tableColumns}
        initialLoading={initialLoading}
        loading={loading}
        page={pagination?.page || 1}
        limit={pagination?.limit || 10}
        total_count={total_marketers}
        tableClassName="table-height-wrapper"
        tableWrapperStyles="table-wrapper-styles"
        onPageChange={(newPage) =>
          dispatch(
            actions.fetchMarketers({
              page: newPage,
              limit: pagination?.limit || 10,
              companyId: companyId
            })
          )
        }
      />
      {/* Form/content */}
    </CommonDashboardWrapper>
  );
};

export default MarketersPage;
